// Backend `detail` string ya da {code, message} nesnesi olabilir (örn. PLAN_LIMIT_REACHED) → her zaman metin döner
export const apiErrorMessage = (err, fallback) => {
  const d = err?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  return d.message || fallback;
};

export const isPlanLimitError = (err) => err?.response?.status === 403 && err?.response?.data?.detail?.code === 'PLAN_LIMIT_REACHED';
